import React from 'react';
import { Modal, ModalHeader, ModalBody, Row, Col } from 'reactstrap';
import moment from 'moment';

export default function VisitDetailsModal({ open, handleCloseModal, visitStats }) {
  if (!visitStats) return null;

  return (
    <Modal isOpen={open} toggle={handleCloseModal} centered>
      <ModalHeader toggle={handleCloseModal}>
        Visit Details
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col md="12" className="mb-3">
            <div className="visit-detail-item">
              <label className="text-muted small">Last Visit Date:</label>
              <p className="mb-0">
                {visitStats?.lastVisitDate
                  ? moment(visitStats.lastVisitDate).format('DD-MM-YYYY HH:mm:ss')
                  : 'No visits yet'}
              </p>
            </div>
          </Col>
          <Col md="12">
            <div className="visit-detail-item">
              <label className="text-muted small">Total Visits:</label>
              <p className="mb-0 font-weight-bold text-primary">
                {visitStats?.totalVisits || 0}
              </p>
            </div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
}
